/* JO MATTER V4 */
(function () {
  var C = window.JMV4 || {};
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'jm-v4-toast'; t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 3500);
  }

  // Shopify preview bar (admin only) sits over bottom buttons: make room for it
  var tries = 0, pb = setInterval(function () {
    if (document.getElementById('PBarNextFrame')) { document.documentElement.classList.add('jm-pbar'); clearInterval(pb); }
    if (++tries > 20) clearInterval(pb);
  }, 500);

  // Theme editor blocks checkout and login pages: say so instead of doing nothing
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('click', function (e) {
      var el = e.target.closest('.jm-cd__checkout, [data-jm-buynow], [data-qv-buy], a[href$="/checkout"], a[href*="/account"]');
      if (!el) return;
      e.preventDefault(); e.stopImmediatePropagation();
      toast('Checkout and login open in Preview, not inside the theme editor.');
    }, true);
  }

  // Announcement bar: swipe left / right to change message
  var vp = document.querySelector('.ann-bar .ann-viewport');
  if (vp) {
    var btns = vp.parentElement.querySelectorAll('.ann-btn'), x0 = null, y0 = 0;
    vp.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    vp.addEventListener('touchend', function (e) {
      if (x0 === null || btns.length < 2) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) btns[dx < 0 ? btns.length - 1 : 0].click();
    });
  }

  // Phone menu drawer: add Wishlist and Log in / My account
  function addDrawerLinks() {
    var ul = document.querySelector('header-drawer .menu-drawer__menu');
    if (!ul || ul.querySelector('.jm-dx')) return !!ul;
    var li0 = ul.querySelector(':scope > li'), a0 = li0 && li0.querySelector('a');
    function item(href, label) {
      var li = document.createElement('li'); li.className = (li0 ? li0.className : '') + ' jm-dx';
      li.style.setProperty('--menu-drawer-animation-index', ul.children.length + 1);
      var a = document.createElement('a'); a.className = a0 ? a0.className : ''; a.href = href; a.textContent = label;
      li.appendChild(a); ul.appendChild(li);
    }
    item(C.wish || '/pages/wishlist', 'Wishlist');
    item(C.account || '/account', C.loggedIn ? 'My account' : 'Log in / Register');
    return true;
  }
  // All Products / collection pages: card images change every 3.5 s, with arrows. Product page untouched.
  var cards = document.querySelectorAll('main[data-template^="collection"] .jm-card__media[data-jm-imgs]');
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  cards.forEach(function (m) {
    var urls = (m.dataset.jmImgs || '').split('|').filter(Boolean), img = m.querySelector('img');
    if (urls.length < 2 || !img) return;
    m.classList.add('jm-cs');
    var i = 0, seen = false, held = 0;
    function show(n) {
      i = (n + urls.length) % urls.length;
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.style.opacity = '0';
      setTimeout(function () { img.src = urls[i]; img.style.opacity = '1'; new Image().src = urls[(i + 1) % urls.length]; }, 180);
    }
    ['prev', 'next'].forEach(function (d) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'jm-cs__btn jm-cs__' + d;
      b.setAttribute('aria-label', d === 'prev' ? 'Previous image' : 'Next image');
      b.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (d === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); held = Date.now(); show(i + (d === 'prev' ? -1 : 1)); });
      m.appendChild(b);
    });
    m.addEventListener('mouseenter', function () { held = Date.now() + 1e9; });
    m.addEventListener('mouseleave', function () { held = Date.now(); });
    m.addEventListener('touchstart', function () { held = Date.now(); }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }).observe(m); else seen = true;
    if (!still) setInterval(function () { if (seen && Date.now() - held > 6000 && !document.hidden) show(i + 1); }, 3500);
  });

  // The drawer can be re-rendered (resize, open), so keep watching and re-add when missing
  addDrawerLinks();
  new MutationObserver(function () { addDrawerLinks(); }).observe(document.body, { childList: true, subtree: true });
})();

// Tab-away title message
(function(){var s=null;document.addEventListener('visibilitychange',function(){if(document.hidden){s=document.title;document.title='Come Back 👋';}else if(s!==null){document.title=s;s=null;}});})();